const defaultDateFormat = 'd/M/yyyy';

export default defaultDateFormat;
